/* eslint-disable */
/// This file is auto generated - do not edit manually

export const spriteSymbolUrl = '/svg_deprecated/sprite/symbol/svg/sprite.symbol.svg?hash=d6cfadea8b65fa50b3a5c6a865fe897c';

export type SvgSpriteType =
    | 'AppleAppStoreBadge'
    | 'Arrow'
    | 'ArrowAutoFill'
    | 'ArrowDown'
    | 'ArrowLeft'
    | 'ArrowLoop'
    | 'ArrowRight'
    | 'ArrowRightSmall'
    | 'ArrowSteptype'
    | 'ArrowSteptypeRight'
    | 'ArrowUp'
    | 'Barcode'
    | 'BasketOutline'
    | 'Bell'
    | 'BellOutline'
    | 'BestForYou'
    | 'BestForYouVertical'
    | 'Bodycare'
    | 'Calendar'
    | 'CameraSimple'
    | 'CameraSolid'
    | 'CameraStroke'
    | 'Card'
    | 'Cart'
    | 'Chat'
    | 'Checkmark'
    | 'ClimateImpact'
    | 'Close'
    | 'ClubMatasIcon'
    | 'ClubMatasIconPlus'
    | 'ClubMatasIconPlusNegative'
    | 'ClubMatasIconPlusSmall'
    | 'ClubMatasIconPlusVertical'
    | 'ClubMatasIconPlusVerticalSmall'
    | 'ClubMatasIconVertical'
    | 'Comment'
    | 'CustomerService'
    | 'Danger'
    | 'Delivery'
    | 'DeliveryGls'
    | 'DeliveryPostNord'
    | 'Derma'
    | 'Diamond'
    | 'Dot'
    | 'Dots'
    | 'Error'
    | 'ExclamationMark'
    | 'Eye'
    | 'EyeSlash'
    | 'Face'
    | 'Facecare'
    | 'Favourite'
    | 'Filter'
    | 'Fitness'
    | 'Fragrance'
    | 'Gear'
    | 'GiftOutline'
    | 'Glasses'
    | 'GooglePlayBadge'
    | 'Hair'
    | 'Haircare'
    | 'Health'
    | 'Home'
    | 'HomeLifestyle'
    | 'Info'
    | 'InfoCircle'
    | 'InfoCircleStroked'
    | 'Information'
    | 'Interests'
    | 'Intetbyttemaerke'
    | 'Kvittering'
    | 'Lamp'
    | 'Lightning'
    | 'Link'
    | 'LinkedIn'
    | 'LivePlay'
    | 'LivePlayCard'
    | 'LiveSoonCard'
    | 'Location'
    | 'LockOpen'
    | 'LockOutline'
    | 'LogoBring'
    | 'LogoBurd'
    | 'LogoBurdTagline'
    | 'LogoDao'
    | 'LogoHelthjem'
    | 'LogoInstabox'
    | 'LogoMatas'
    | 'LogoStories'
    | 'Mail'
    | 'Makeup'
    | 'MakeupV2'
    | 'MapsPin'
    | 'MapsPinOutline'
    | 'MatasLiveLogo'
    | 'MatasStore'
    | 'Menu'
    | 'ModifaceSplashOutlined'
    | 'News'
    | 'Offer'
    | 'OTC'
    | 'Package'
    | 'Pause'
    | 'PaymentAnyday'
    | 'PaymentApplePay'
    | 'PaymentDankort'
    | 'PaymentGooglePay'
    | 'PaymentKlarna'
    | 'PaymentMasterCard'
    | 'PaymentMobilePay'
    | 'PaymentMobilePayHorizontal'
    | 'PaymentMobilePayVertical'
    | 'PaymentSwish'
    | 'PaymentVipps'
    | 'PaymentVisa'
    | 'Person'
    | 'Phone'
    | 'PlayArrow'
    | 'PlaySimple'
    | 'Product'
    | 'Return'
    | 'ReviewStars'
    | 'Search'
    | 'SmallX'
    | 'Smile'
    | 'SmileStroke'
    | 'SocialFacebook'
    | 'SocialPinterest'
    | 'Speech'
    | 'Star'
    | 'Subscription'
    | 'ThumbsDown'
    | 'ThumbsUp'
    | 'TimeDelivery'
    | 'Triangle'
    | 'Truck'
    | 'Twitter'
    | 'UspDelivery'
    | 'UspExchange'
    | 'UspReturn'
    | 'UspSelection'
    | 'VideoCamera'
    | 'VideoPlay'
    | 'X';

export const spriteIndexObj = {
    AppleAppStoreBadge: { id: 'icons_apple_appstore-badge', classList: 'icon--apple-appstore-badge' },
    Arrow: { id: 'icons_arrow' },
    ArrowAutoFill: { id: 'icons_arrow-auto-fill', classList: 'icon--arrow-auto-fill' },
    ArrowDown: { id: 'icons_arrow', classList: 'icon--arrow-down' },
    ArrowLeft: { id: 'icons_arrow', classList: 'icon--arrow-left' },
    ArrowLoop: { id: 'icons_arrow_loop' },
    ArrowRight: { id: 'icons_arrow', classList: 'icon--arrow-right' },
    ArrowRightSmall: { id: 'icons_arrow-right_small' },
    ArrowSteptype: { id: 'icons_arrow_steptype_right', classList: 'icon--arrow-steptype' },
    ArrowSteptypeRight: { id: 'icons_arrow_steptype_right' },
    ArrowUp: { id: 'icons_arrow', classList: 'icon--arrow-up' },
    Barcode: { id: 'icons_barcode', classList: 'icon--barcode' },
    BasketOutline: { id: 'icons_basket-outline', classList: 'icon--basket-outline' },
    Bell: { id: 'icons_bell', classList: 'icons--bell' },
    BellOutline: { id: 'icons_bell_outline', classList: 'icons--bell-outline' },
    BestForYou: { id: 'icons_btd', classList: 'icons--btd' },
    BestForYouVertical: { id: 'icons_btd-vertical', classList: 'icons--btd-vertical' },
    Bodycare: { id: 'icons_bodycare' },
    Calendar: { id: 'icons_calendar', classList: 'icon--calendar' },
    CameraSimple: { id: 'icons_camera-simple', classList: 'icon--camera-simple' },
    CameraSolid: { id: 'icons_camera_solid' },
    CameraStroke: { id: 'icons_camera_stroke' },
    Card: { id: 'icons_card', classList: 'icon--card' },
    Cart: { id: 'icons_cart', classList: 'icon--cart' },
    Chat: { id: 'icons_chat', classList: 'icon--chat' },
    Checkmark: { id: 'icons_checkmark', classList: 'icon--checkmark' },
    ClimateImpact: { id: 'icons_climateImpact' },
    Close: { id: 'icons_x', classList: 'icon--close' },
    ClubMatasIcon: { id: 'icons_clubmatas-logo', classList: 'icon--clubmatas-logo' },
    ClubMatasIconPlus: { id: 'icons_clubmatas-logo-plus', classList: 'icon--clubmatas-logo icon--clubmatas-logo-plus' },
    ClubMatasIconPlusNegative: { id: 'icons_clubmatas-logo-plus-negative', classList: 'icon--clubmatas-logo' },
    ClubMatasIconPlusSmall: { id: 'icons_clubmatas-logo-plus-small', classList: 'icon--clubmatas-logo icon--clubmatas-logo-plus' },
    ClubMatasIconPlusVertical: { id: 'icons_clubmatas-logo-plus-vertical', classList: 'icon__clubmatas-logo-plus-vertical' },
    ClubMatasIconPlusVerticalSmall: { id: 'icons_clubmatas-logo-plus-vertical-small', classList: 'icon__clubmatas-logo-plus-vertical' },
    ClubMatasIconVertical: { id: 'icons_clubmatas-logo-vertical', classList: 'icon--clubmatas-logo-vertical' },
    Comment: { id: 'icons_comment', classList: 'icon--comment' },
    CustomerService: { id: 'icons_customer-service', classList: 'icon--customer-service' },
    Danger: { id: 'icons_danger', classList: 'icon--danger' },
    Delivery: { id: 'icons_delivery', classList: 'icon--delivery' },
    DeliveryGls: { id: 'icons_GLS', classList: 'icon--delivery icon--gls' },
    DeliveryPostNord: { id: 'icons_postnord', classList: 'icon--delivery icon--postdanmark' },
    Derma: { id: 'icons_derma', classList: 'icon--derma' },
    Diamond: { id: 'icons_diamond', classList: 'icon--diamond' },
    Dot: { id: 'icons_dot' },
    Dots: { id: 'icons_dots', classList: 'icon--dots' },
    Error: { id: 'icons_exclamation-mark', classList: 'icon--error' },
    ExclamationMark: { id: 'icons_exclamation-mark', classList: 'icon--exclamation-mark' },
    Eye: { id: 'icons_eye' },
    EyeSlash: { id: 'icons_eye-slash' },
    Face: { id: 'icons_face', classList: 'icon--face' },
    Facecare: { id: 'icons_facecare' },
    Favourite: { id: 'icons_favourite', classList: 'icon--favourite' },
    Filter: { id: 'icons_filter', classList: 'icon--filter' },
    Fitness: { id: 'icons_fitness' },
    Fragrance: { id: 'icons_fragrance' },
    Gear: { id: 'icons_gear' },
    GiftOutline: { id: 'icons_gift-outline', classList: 'icon--gift-outline' },
    Glasses: { id: 'icons_glasses' },
    GooglePlayBadge: { id: 'icons_google-play-badge', classList: 'icon--google-play-badge' },
    Hair: { id: 'icons_hair' },
    Haircare: { id: 'icons_haircare' },
    Health: { id: 'icons_health' },
    Home: { id: 'icons_home', classList: 'icon--home' },
    HomeLifestyle: { id: 'icons_homelifestyle' },
    Info: { id: 'icons_info', classList: 'icon--info' },
    InfoCircle: { id: 'icons_info_circle', classList: 'icon--info-circle' },
    InfoCircleStroked: { id: 'icons_info_circle_stroked' },
    Information: { id: 'icons_information', classList: 'icons--information' },
    Interests: { id: 'icons_interests' },
    Intetbyttemaerke: { id: 'icons_intetbyttemaerke', classList: 'icon--intetbyttemaerke' },
    Kvittering: { id: 'icons_kvittering', classList: 'icon--kvittering' },
    Lamp: { id: 'icons_lamp' },
    Lightning: { id: 'icons_lightning', classList: 'icon--lightning' },
    Link: { id: 'icons_link', classList: 'icons--link' },
    LinkedIn: { id: 'icons_linkedIn', classList: 'icon--linkedIn' },
    LivePlay: { id: 'icons_matas-live-play', classList: 'icon--matas-live-play' },
    LivePlayCard: { id: 'icons_matas-live-play-card', classList: 'icon--matas-live-play-card' },
    LiveSoonCard: { id: 'icons_matas-live-soon-card', classList: 'icon-matas-live-soon-card' },
    Location: { id: 'icons_location', classList: 'icon--location' },
    LockOpen: { id: 'icons_lock_open', classList: 'icon--lock-open' },
    LockOutline: { id: 'icons_lock-outline', classList: 'icon--lock-outline' },
    LogoBring: { id: 'icons_logo-bring', classList: 'icon--delivery icon--logo-bring' },
    LogoBurd: { id: 'icons_logo-burd', classList: 'icon--logo-burd' },
    LogoBurdTagline: { id: 'icons_logo-burd-tagline', classList: 'icon--logo-burd-tagline' },
    LogoDao: { id: 'icons_logo-dao', classList: 'icon--logo-dao' },
    LogoHelthjem: { id: 'icons_logo-helthjem', classList: 'icon--delivery icon--logo-helthjem' },
    LogoInstabox: { id: 'icons_logo-instabox', classList: 'icon--delivery icon--instabox' },
    LogoMatas: { id: 'icons_logo-matas', classList: 'icon--logo' },
    LogoStories: { id: 'icons_logo-stories', classList: 'icon--logo-stories' },
    Mail: { id: 'icons_mail', classList: 'icon--mail' },
    Makeup: { id: 'icons_makeup' },
    MakeupV2: { id: 'icons_makeup_v2' },
    MapsPin: { id: 'icons_maps-pin', classList: 'icon--maps-pin' },
    MapsPinOutline: { id: 'icons_pin_outline', classList: 'icon--maps-pin-outline' },
    MatasLiveLogo: { id: 'icons_matas-live-logo', classList: 'icon--matas-live-logo' },
    MatasStore: { id: 'icons_matas-store', classList: 'icon--matas-store' },
    Menu: { id: 'icons_menu', classList: 'icon--menu' },
    ModifaceSplashOutlined: { id: 'icons_modiface_splash_outlined' },
    News: { id: 'icons_news', classList: 'icon--news' },
    Offer: { id: 'icons_offer' },
    OTC: { id: 'icons_otc', classList: 'icon--otc' },
    Package: { id: 'icons_package', classList: 'icons--package' },
    Pause: { id: 'icons_pause', classList: 'icon--pause' },
    PaymentAnyday: { id: 'icons_anyday', classList: 'icon--payment icon--anyday' },
    PaymentApplePay: { id: 'icons_applepay', classList: 'icon--payment icon--applepay' },
    PaymentDankort: { id: 'icons_dankort', classList: 'icon--payment icon--dankort' },
    PaymentGooglePay: { id: 'icons_googlepay', classList: 'icon--payment icon--googlepay' },
    PaymentKlarna: { id: 'icons_klarna', classList: 'icon--payment icon--klarna' },
    PaymentMasterCard: { id: 'icons_mastercard', classList: 'icon--payment icon--mastercard' },
    PaymentMobilePay: { id: 'icons_mobilepay-vertical', classList: 'icon--payment icon--mobilepay' },
    PaymentMobilePayHorizontal: { id: 'icons_mobilepay-horizontal', classList: 'icon--payment icon--mobilepay-horizontal' },
    PaymentMobilePayVertical: { id: 'icons_mobilepay-vertical', classList: 'icon--payment icon--mobilepay-vertical' },
    PaymentSwish: { id: 'icons_swish', classList: 'icon--payment icon--swish' },
    PaymentVipps: { id: 'icons_vipps', classList: 'icon--payment icon--vipps' },
    PaymentVisa: { id: 'icons_visa', classList: 'icon--payment icon--visa' },
    Person: { id: 'icons_person', classList: 'icon--person' },
    Phone: { id: 'icons_phone', classList: 'icon--phone' },
    PlayArrow: { id: 'icons_play-arrow', classList: 'classList: icon--play-arrow' },
    PlaySimple: { id: 'icons_play-simple', classList: 'icon--play-simple' },
    Product: { id: 'icons_product', classList: 'icon--product' },
    Return: { id: 'icons_return' },
    ReviewStars: { id: 'icons_review-stars', classList: 'icon--rating' },
    Search: { id: 'icons_search', classList: 'icon--search' },
    SmallX: { id: 'icons_small-x' },
    Smile: { id: 'icons_smile', classList: 'icon--smile' },
    SmileStroke: { id: 'icons_smile-stroke', classList: 'icon--smile-stroke' },
    SocialFacebook: { id: 'icons_facebook', classList: 'icon--facebook' },
    SocialPinterest: { id: 'icons_pinterest', classList: 'icons--pinterest' },
    Speech: { id: 'icons_speech', classList: 'icon--speech' },
    Star: { id: 'icons_star', classList: 'icon--star' },
    Subscription: { id: 'icons_abonnement', classList: 'icon--subscription' },
    ThumbsDown: { id: 'icons_thumbs', classList: 'icon--thumbs-down' },
    ThumbsUp: { id: 'icons_thumbs' },
    TimeDelivery: { id: 'icons_time-delivery', classList: 'icon--time-delivery' },
    Triangle: { id: 'icons_triangle', classList: 'icon--triangle' },
    Truck: { id: 'icons_truck', classList: 'icons--truck' },
    Twitter: { id: 'icons_twitter', classList: 'icon--twitter' },
    UspDelivery: { id: 'icons_usp-delivery', classList: 'icon--usp-delivery' },
    UspExchange: { id: 'icons_matas-store', classList: 'icon--usp-exchange' },
    UspReturn: { id: 'icons_usp-return', classList: 'icon--usp-return' },
    UspSelection: { id: 'icons_usp-selection', classList: 'icon--usp-selection' },
    VideoCamera: { id: 'icons_videocamera', classList: 'icon--videocamera' },
    VideoPlay: { id: 'icons_play', classList: 'icon--play' },
    X: { id: 'icons_x', classList: 'icon--x' }
};

